import { useTranslations } from '@vocab/react';
import { Inline, Badge, TooltipRenderer, Text } from 'braid-design-system';

import appTranslations from 'src/App/App.vocab';

import translations from '../.vocab';

export const StatusBadges = ({
  status,
  role,
}: {
  status: string; // https://github.com/SEEK-Jobs/adv-user-management-ui/pull/37#discussion_r883207944
  role: string;
}) => {
  const { t } = useTranslations(translations);
  const { t: appTrans } = useTranslations(appTranslations);

  return (
    <>
      {(status === 'Pending' || role === 'Administrator') && (
        <Inline space="small">
          {role === 'Administrator' ? (
            <TooltipRenderer
              id="admin-tooltip"
              tooltip={<Text>{t('Admin role description')}</Text>}
            >
              {({ triggerProps }) => (
                <Badge tone="info" {...triggerProps}>
                  {t('Admin badge')}
                </Badge>
              )}
            </TooltipRenderer>
          ) : null}
          {status === 'Pending' ? (
            <TooltipRenderer
              id="pending-tooltip"
              tooltip={<Text>{appTrans('Pending user description')}</Text>}
            >
              {({ triggerProps }) => (
                <Badge tone="caution" {...triggerProps}>
                  {appTrans('Pending activation badge')}
                </Badge>
              )}
            </TooltipRenderer>
          ) : null}
        </Inline>
      )}
    </>
  );
};
